export default __webpack_public_path__ + "static/media/vicop09.b4d16d9a.jpg";